/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/heroSection.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IHeroSectionMethods extends IPluginMethodMap {
  getHeroSectionProps(args: any): Promise<any>;
}

export class HeroSectionService implements IAgentPlugin {
  readonly methods: IHeroSectionMethods;

  constructor() {
    this.methods = {
      getHeroSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const storageSrv = StorageModule.getInstance();
    const localStorage = storageSrv?.get("theme", "local");
    const openReg = localStorage?.openRegEnabled;

    let logoChanged = {
      ...config,
      heroDarkButtonItem: {
        name: "Sign Up Now",
        link: openReg === "true" ? "/register" : "/sign-in",
      },
    };

    return { ...(logoChanged || {}) };
  }
}
